// @flow

import React from 'react';
import { withHandlers, type HOC } from 'recompose';
import glamorous from 'glamorous';

import Tappable from 'app/components/commons/Tappable';
import PlayerAvatar from 'app/components/challenge/PlayerAvatar';

type OuterProps = {
  children: any,
  id: string,
  isHome?: boolean,
  onClick: string => void,
  selected?: boolean
};

type InnerProps = {
  children: any,
  isHome?: boolean,
  image?: string,
  onClick: () => void,
  selected?: boolean,
  disabled?: boolean
};

const defaultProps = {
  image: undefined,
  isHome: false,
  selected: false,
  disabled: false
};

const Button = glamorous.span(
  ({ theme, disabled, hasImage }: { theme: Theme }) => ({
    alignItems: 'center',
    border: `1px solid ${theme.color.basis5}`,
    color: theme.color.basis1,
    display: 'flex',
    justifyContent: 'center',
    fontWeight: theme.fontWeight.demiBold,
    padding: 2,
    opacity: disabled ? 0.4 : 1,
    width: hasImage ? 75 : 60,
    '&:first-of-type': {
      borderRadius: '3px 0 0 3px',
      borderRight: 'none'
    },
    '&:last-child': {
      borderRadius: '0 3px 3px 0'
    }
  }),
  props => ({
    backgroundColor: props.selected ? props.theme.color.white : props.theme.color.basis6
  })
);

const HomeIcon = glamorous.span(
  ({ theme }) => ({
    color: theme.color.basis4,
    paddingRight: 2,
    [theme.mediaQuery.desktopAndUp]: {
      fontSize: '0.6rem'
    }
  }),
  'ion-home'
);

const StyledPlayerAvatar = glamorous(PlayerAvatar)(({ theme }) => ({
  marginLeft: theme.spacing.tiny,
  marginRight: theme.spacing.tiny
}));

function SingleTeamButton({ children, image, isHome, onClick, selected, disabled }: InnerProps) {
  return (
    <Tappable
      component={Button}
      onTap={disabled ? undefined : onClick}
      selected={selected}
      disabled={disabled}
      hasImage={!!image}
    >
      {isHome && <HomeIcon />}
      {image && <StyledPlayerAvatar image={image} size="small" />}
      {children}
    </Tappable>
  );
}

SingleTeamButton.defaultProps = defaultProps;

const enhancer: HOC<OuterProps, InnerProps> = withHandlers({
  onClick: props => () => {
    props.onClick(props.id);
  }
});

export default enhancer(SingleTeamButton);
